import styled from 'styled-components'

import { helpers } from '../../../../../styles/theme'
import { ButtonIcon } from '../ButtonIcon'

export const Button = styled(ButtonIcon)`
	color: ${helpers.color.input.buttonClear};
	height: 100%;
	margin: 0;
	width: 40px;

	&:last-child {
		border-radius: 0 2px 2px 0;
	}

	&:hover:enabled {
		background-color: ${helpers.color.input.buttonClearBackgroundHover};
		color: ${helpers.color.input.buttonClearHover};
	}
`
